module.exports = __webpack_public_path__ + "img/search.91c05d3c.svg";